<template>
  <div style="padding-top: 3em;">
    <h4 class="title">Attachment Tester</h4>
    <div v-if="message" class="notification is-primary">{{ message }}</div>
    <form-wizard
      dusk="form-wizard"
      @submit.prevent="onSubmit"
      @on-complete="onSubmit"
      shape="tab"
      color="#17C4EE"
      title
      subtitle
      ref="wizard"
      v-if="!message"
    >
      <input type="hidden" v-model="form" />

      <div style="padding: 1em 0px; color: #aaa;">
        <small>* Required Fields</small>
      </div>

      <!-- ************************* -->
      <!-- TAB #1 - INCIDENT DETAILS -->
      <!-- ************************* -->
      <tab-content title="Attachment Details" :before-change="validateStep1">
        <div class="columns">
          <div class="column is-8">
            <label class="label">Please drop file here</label>
            <FileDragDropInstant v-on:fileIDs="appendFileIDs" v-on:removeFileID="removeFileID"></FileDragDropInstant>
          </div>
        </div>
      </tab-content>

      <div class="modal" v-bind:class="{'is-active' : loading}">
        <div class="modal-background"></div>
        <div class="modal-content has-text-centered">
          <h1 class="title is-3 has-text-light">Please wait...</h1>
          <button
            class="button is-info is-loading is-fullwidth is-large"
            style="font-size: 5em; background: transparent;"
          >Submitting</button>
        </div>
      </div>
    </form-wizard>
  </div>
</template>

<script>
import FileDragDropInstant from "../../../../../../Modules/FileManagement/Resources/assets/js/components/FileDragDropInstant.vue";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  components: {
    FileDragDropInstant,
    FormWizard,
    TabContent
  },
  props: {
    form: {}
  },
  data() {
    return {
      formTitle: this.form,
      message: "",
      submitted: false,
      loading: false,
      fileIDs: []
    };
  },
  watch: {
    message: function(val) {
      if (!val === "") {
        this.loading = false;
      }
    }
  },
  methods: {
    // FILE ATTACHMENT HANDLING
    saveFileIDs(value) {
      this.fileIDs = value;
    },
    appendFileIDs(value) {
      console.log("add ID: " + value);
      let self = this;
      value.forEach(function(v) {
        if (self.fileIDs.indexOf(v) < 0) {
          self.fileIDs.push(v);
        }
      });
    },
    removeFileID(value) {
      this.fileIDs.splice(this.fileIDs.indexOf(value), 1);
    },

    validateStep1() {
      this.$v.formStep1.$touch();
      return !this.$v.formStep1.$invalid;
    },

    onSubmit() {
      this.submitForm();
    }
  }
};
</script>




// WEBPACK FOOTER //
// Modules/OnlineForm/Resources/assets/js/components/testAttachments.vue